import { render, staticRenderFns } from "./FiltrosPrincipais.vue?vue&type=template&id=43b74f4e&scoped=true"
import script from "./FiltrosPrincipais.vue?vue&type=script&lang=js"
export * from "./FiltrosPrincipais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b74f4e",
  null
  
)

export default component.exports